import { Controller } from "stimulus";
import Rails from "@rails/ujs";

// Bridges the data table's selection into hidden form fields (selection_mode +
// selected_items, materialised server-side via DataTable::Selectable) and, like
// the facilitator view, confirms before saving when attendance is being removed
// from a learner who was already registered.
export default class extends Controller {
  static targets = ['selectionMode', 'selectedItems'];

  static values = {
    attendingIds: { type: Array, default: [] },
    confirmTitle: String,
    confirmMessage: String,
    confirmAllow: String,
    confirmCancel: String
  };

  connect() {
    this.selectionMode = this.selectionModeTarget.value;
    this.selectedIds = new Set(this.attendingIdsValue.map(String));

    this.boundSync = this.sync.bind(this);
    document.addEventListener('promote:data-table:selection', this.boundSync);
  }

  disconnect() {
    document.removeEventListener('promote:data-table:selection', this.boundSync);
  }

  sync(event) {
    const { selectionMode, selectedItems } = event.detail;

    this.selectionMode = selectionMode;
    this.selectedIds = new Set(Array.from(selectedItems.keys()).map(String));

    this.selectionModeTarget.value = selectionMode;
    this.selectedItemsTarget.value = Array.from(selectedItems.keys()).join(',');
  }

  save(event) {
    if (this.removesAttendance()) {
      Rails.confirm(null, event.currentTarget, this.confirmDataset(), {
        confirmCallback: () => this.element.requestSubmit()
      });
      return;
    }

    this.element.requestSubmit();
  }

  // True when a learner who was attending when the list opened is no longer
  // selected — i.e. attendance is being removed.
  removesAttendance() {
    if (this.selectionMode === 'all') return false;
    if (this.selectionMode === 'none') return this.attendingIdsValue.length > 0;

    if (this.selectionMode === 'all_except') {
      return this.attendingIdsValue.some((id) => this.selectedIds.has(String(id)));
    }

    return this.attendingIdsValue.some((id) => !this.selectedIds.has(String(id)));
  }

  confirmDataset() {
    return {
      confirmTitle: this.confirmTitleValue,
      confirmMessage: this.confirmMessageValue,
      confirmAllow: this.confirmAllowValue,
      confirmCancel: this.confirmCancelValue
    };
  }
}
